const scroll = {
    ['&::-webkit-scrollbar']: {
      height: 5
    },
    ['&::-webkit-scrollbar-track']: {
      background: '#E3E3E3',
      borderRadius: '10px'
    },
    ['&::-webkit-scrollbar-thumb']: {
      height: 5,
      width: 29,
      background: '#B4BCC3',
      borderRadius: '10px'
    }
  };

export const styles = {
    block: {
        position: 'relative',
        width: '100%',
        padding: [17, 0, 10, 10],
        background: '#FFFFFF',
        borderBottom: '1px solid #E3E3E3',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
        overflowX: 'overlay',
        cursor: 'grab',
        ...scroll,
    },
    title: {
        margin: 0,
        marginBottom: 10,
        fontFamily: 'Open Sans, Arial, sans-serif',
        fontWeight: 600,
        fontSize: '12px',
        lineHeight: '135%',
        letterSpacing: '0.75px',
        textTransform: 'uppercase',
        color: '#313140',
    },
    container: {
        display: 'flex',
        whiteSpace: 'nowrap',
        paddingBottom: 10,

        '& > label > span': {
            fontSize: '14px',
            padding: [7, 14],
        },
    },
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
